import {
  MEDIA_GROUP_PREVIEW,
  MEDIA_GROUP_NEW,
  MEDIA_GROUP_UPDATE,
  MEDIA_GROUP_REMOVE,
  MEDIA_GROUP_PROCESS_SUCCESS,
  MEDIA_GROUP_DATASOURCE_SUCCESS,
  MEDIA_GROUP_SEARCH,
  MEDIA_GROUP_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MEDIA_GROUP_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case MEDIA_GROUP_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case MEDIA_GROUP_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case MEDIA_GROUP_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case MEDIA_GROUP_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case MEDIA_GROUP_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case MEDIA_GROUP_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case MEDIA_GROUP_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}